module.exports = __webpack_public_path__ + "img/hipercard.9d8aeef5.svg";